/* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { format, fromUnixTime, getUnixTime } from 'date-fns';
import { connect } from 'react-redux';
import $ from 'jquery';
import jwt_decode from "jwt-decode";
import authActions from '../../redux/features/auth/actions';
import store from '../../redux/index';
import config from '../../config/config';

const { API_BASE_URL } = config;

const initializeScript = src =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve();
    script.onError = e => reject(e);
    document.body.appendChild(script);
  });

const AuthorizationHandler = ({
  authToken,
  children,
  keycloak,
  loadAuthData,
  logoutUser,
  setAuthToken,
  setKeycloakInstance,
}) => {
  // const [TokenData,setTokenData]=useState();
  const SSO_SESSION_CHECK_INTERVAL_MS = 60000;

  const checkSSOSessionStatePeriodically = () => {
    keycloak
      .loadUserInfo()
      .then(() =>
        setTimeout(
          checkSSOSessionStatePeriodically,
          SSO_SESSION_CHECK_INTERVAL_MS,
        ),
      )
      .catch(error => {
        console.log('failed user check', error);
        // eslint-disable-next-line no-use-before-define
        refreshTokenAndContinueUserSessionCheckElseLogout();
      });
  };

  const refreshToken = () =>
    keycloak
      .updateToken(-1)
      .then(refreshed => {
        console.log('refreshedToken: refreshed:', refreshed);
        setAuthToken(keycloak.token);
        localStorage.clear();
      });

  const refreshTokenAndContinueUserSessionCheckElseLogout = () =>
    refreshToken()
      .then(() => checkSSOSessionStatePeriodically())
      .catch(error => {
        console.error(
          'Failed to refresh the token, or the session has expired. Logging user out...',
          error,
        );
        logoutUser();
      });

  const getISTTime = unixTimestamp =>
    format(fromUnixTime(unixTimestamp), 'hh:mma');
  
  let email = '';
  let name = '';
  let userdata = '';

  const setRefreshTokenTimeout = () => {
    const TokenData = keycloak.token;
    const decoded = jwt_decode(TokenData);
    userdata = decoded.preferred_username;
    email = decoded.email;
    name = decoded.name;
    $.ajax({
      url: `${API_BASE_URL}/api/token/auth`,
      method: "POST",
      dataType: 'json',
      data: { username:userdata },
      success: (result) => {
        if (result === 'unauthrized'){
          window.location.replace(config.HOME_UI_BASE_URL);
        } else{
          localStorage.setItem("ApiToken", result.access);
          sessionStorage.setItem("userRole", result.SuperUserRole);
          localStorage.setItem("role", result.roles);
          store.dispatch(authActions.setDjangoAuthData({
            access: result.access,
            roles: result.roles,
            userInfo: { userdata, email, name },
          }));
          window.dispatchEvent(new Event('storage'));
          window.addEventListener('storage', () => {
            console.log("Change to local storage!");
            // ...
          })
          $.ajax({
            url:`${API_BASE_URL}/api/save_login`,
            headers: {
              "Authorization" : `Bearer ${result.access}`
            },
            method: "POST",
            dataType: 'json',
            data: { UserName:userdata,EmailId:email,FullName:name },
            success: (data) => {
              $("#ipAddress").html(data.jsonData);
            }
          });
        }
      }
    });
  }

  const setRefreshBeforeTimeout = () => {
    setRefreshTokenTimeout();
    const { sub: userID, exp, iat,preferred_username,email, name, auth_time: authTime } = keycloak.tokenParsed;
    const remainingTimeToRefreshInMS = 120000;
    console.info(
      `setting token refresh - userID: ${userID},${preferred_username},${email},${name} ` +
      `exp:${getISTTime(exp)} iat:${getISTTime(iat)} ` +
      `auth:${getISTTime(authTime)}`,
    );
    localStorage.setItem("preferred_username",preferred_username);
    localStorage.setItem("email",email);
    localStorage.setItem("name",name);

    return setTimeout(() => {
      console.info(`userID: ${userID}: calling refresh before token expiry`);
      refreshToken().catch(err =>
        console.error(`failed to refresh token ${err}`),
      );
    }, remainingTimeToRefreshInMS);
  };


  useEffect(() => {
    // initializeScript(`${window.epAppData.AUTH_ENDPOINT}/js/keycloak.js`)
    initializeScript(`${window.epAppData.AUTH_ENDPOINT}js/keycloak.js`)
      .then(() => setKeycloakInstance(window.Keycloak('/keycloak.json')))
      .catch(err => console.log('failed to load keycloak script: err -', err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    if (!authToken) return null;
    const timeout = setRefreshBeforeTimeout();
    return () => clearTimeout(timeout);
  }, [authToken]);

  useEffect(() => {
    if (!keycloak) return;
    keycloak
      .init({
        onLoad: 'login-required',
        promiseType: 'native',
        pkceMethod: 'S256',
        checkLoginIframe: false,
      })
      .then(authenticated => {
        // set globally so that axios instance can access token
        window.keycloak = keycloak;
        if (authenticated) {
          loadAuthData(keycloak.token, authenticated);
          checkSSOSessionStatePeriodically();
          setRefreshTokenTimeout();
        }
      })
      .catch(error => console.log('keycloak init error', error));
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [keycloak, loadAuthData]);

  return <>{children}</>;
};

AuthorizationHandler.defaultProps = {
  children: null,
  keycloak: null,
};

AuthorizationHandler.propTypes = {
  children: PropTypes.node,
  loadAuthData: PropTypes.func.isRequired,
  logoutUser: PropTypes.func.isRequired,
  keycloak: PropTypes.object,
  setKeycloakInstance: PropTypes.func.isRequired,
  setAuthToken: PropTypes.func.isRequired,
  authToken: PropTypes.string,
};

export default connect(
  state => ({
    keycloak: state.auth.keycloak,
    authToken: state.auth.authToken,
  }),
  {
    setKeycloakInstance: authActions.setKeycloakInstance,
    loadAuthData: authActions.loadAuthData,
    logoutUser: authActions.logoutUser,
    setAuthToken: authActions.setAuthToken,
  },
)(AuthorizationHandler);
